import React, {useState} from 'react';
import PropTypes from 'prop-types';
import apiHelper from 'helpers/api-helper';
import './change-thoughts-facilitator.scss';

const ChangeThoughtsFacilitator = ({partIndex, minigameData, gameId, minigameGameData}) => {
	const [isUpdatingMinigame, setIsUpdatingMinigame] = useState(false);

	const thoughtOptions = 
		minigameData && 
		minigameData.parts && 
		minigameData.parts.length > partIndex &&
		minigameData.parts[partIndex].options ?
			minigameData.parts[partIndex].options : [];

	/**
	 * Remove group submission
	 * @param {number} submissionIndex 
	 * @returns 
	 */
	const removeSubmission = (submissionIndex) => {
		if (isUpdatingMinigame) return;
		setIsUpdatingMinigame(true);
		apiHelper('facilitator/remove-minigame-submission', {
			gameId,
			minigameId: minigameData.id,
			submissionIndex
		}).then(
			(response)=>{
				if (response.status === 'success') {
					setIsUpdatingMinigame(false);
				} else {
					console.error(response);
					setIsUpdatingMinigame(false);
				}
			},
			(error) => {
				console.error(error);
				setIsUpdatingMinigame(false);
			}
		);
	};

	return (
		<div className={'ChangeThoughtsFacilitator ' + minigameData.id}>
			<div className="ChangeThoughtsFacilitator-part2">
				<div className="ChangeThoughtsFacilitator-title">
					<span>{minigameData.parts[partIndex].title}</span></div>
				<div className="ChangeThoughtsFacilitator-wrap">
					<div className="ChangeThoughtsFacilitator-thoughtOptions">
						{thoughtOptions.map((option, index) => {
							return (
								<div key={index} className="ChangeThoughtsFacilitator-option">
									<span>{option}</span>
								</div>
							);
						})}
					</div>
					<div className="ChangeThoughtsFacilitator-submissions">
						{(minigameGameData && minigameGameData.submissions) && 
							minigameGameData.submissions.map((submission, index) => {
								return (
									<div key={index} className="ChangeThoughtsFacilitator-submission">
										<span>{submission.value}</span>
										<div 
											className="ChangeThoughtsFacilitator-removeSubmissionBtn" 
											onClick={() => {removeSubmission(index);}}
										/>
									</div>
								);
							})
						}
					</div>
				</div>
			</div>
		</div>
	);
};

ChangeThoughtsFacilitator.propTypes = {
	partIndex: PropTypes.number.isRequired,
	minigameData: PropTypes.object.isRequired,
	gameId: PropTypes.string.isRequired,
	minigameGameData: PropTypes.object
};

export default ChangeThoughtsFacilitator;
